import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["name", "value", "placeholder"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["c-search", _ctx.variantClass])
  }, [
    _createVNode(_component_Icon, {
      name: "search",
      size: "sm",
      class: "c-search__icon"
    }),
    _createElementVNode("input", {
      ref: "inputElement",
      name: _ctx.$attrs.name,
      type: "search",
      class: "c-search__input",
      value: _ctx.modelValue,
      placeholder: _ctx.$attrs.placeholder || '',
      onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
    }, null, 40, _hoisted_1)
  ], 2))
}